<template>
  <button v-if="sortedList.length != 0" class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <font-awesome-icon :icon="['fas', 'paperclip']" />
    {{ $t('global.attachments') }} ({{ sortedList.length }})
  </button>
  <ul class="dropdown-menu">
    <li v-for="item in sortedList" :key="item.id">
      <button class="dropdown-item text-primary" @click.prevent="downloadAttachment(item.id)">
        <font-awesome-icon v-if="item.contentType === 'text/csv'" :icon="['fas', 'file-csv']" />
        <font-awesome-icon v-else-if="item.contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" :icon="['fas', 'file-xls']" />
        <font-awesome-icon v-else :icon="['fas', 'file']" />
        {{ item.fileName }}
      </button>
    </li>
  </ul>
  <span class="input-group-text" v-if="sortedList.length == 0">{{ $t('global.noAttachments') }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDeliveriesStore } from '@/stores';
import api from '@/services/api';

const deliveriesStore = useDeliveriesStore();

const props = defineProps({
  deliveryId: { type: Number, required: true }
});

const sortedList = computed(() => {
  if (currentDeliveryAttachments.value === undefined) {
    return [];
  }
  return [...currentDeliveryAttachments.value].sort((a, b) =>
    a.fileName.localeCompare(b.fileName)
  );
});

const currentDeliveryAttachments = computed(() => {
  return deliveriesStore.attachments;
});

const downloadAttachment = (attachmentId: number) => {
  api.get<Blob>(`v1.0/deliveries/${props.deliveryId}/attachments/${attachmentId}`, {
      responseType: 'blob'
    })
    .then(response => {
      const blob = new Blob([response.data], { type: String(response.headers['content-type'] ?? '') });
      const link = document.createElement('a');
      const contentDisposition = response.headers['content-disposition'] as string;
      const fileName = parseContentDisposition(contentDisposition);
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', fileName ?? `attachment_${props.deliveryId}_${attachmentId}.dat`);
      link.click();
      URL.revokeObjectURL(link.href);
    })
    .catch(console.error);
};

function parseContentDisposition(contentDisposition: string): string | null {
    // Regular expression to match filename*
    const filenameStarRegex = /filename\*=([^;]+)/;
    // Regular expression to match filename
    const filenameRegex = /filename=([^;]+)/;

    let matches = filenameStarRegex.exec(contentDisposition);
    if (matches && matches[1]) {
        // Decode the encoded filename*
        return decodeURIComponent(matches[1].replace(/^UTF-8''/, ''));
    }

    matches = filenameRegex.exec(contentDisposition);
    if (matches && matches[1]) {
        // Return the plain filename, stripping any surrounding quotes
        return matches[1].replace(/(^"|"$)/g, '');
    }

    // Return null if no filename is found
    return null;
}
</script>
